itsoftApp.createModule("subMenu", function () {
    // const menuWrapper = document.querySelector(".js-menu-wrapper");
    // const menuButton = document.querySelector(".js-sub-menu-trigger");
    // // let clickFlag = false;

    // const activateSubMenu = function () {
    //     menuWrapper.classList.add("js-active-submenu");
    //     menuButton.classList.add("js-active");
    // }

    // const deactivateSubMenu = function () {
    //     menuWrapper.classList.remove("js-active-submenu");
    //     menuButton.classList.remove("js-active");
    // }

    // if (menuButton) {
    //     document.body.addEventListener("click", function (evt) {
    //         if (evt.target.closest(".main-menu__extra") && !evt.target.closest(".main-menu__more-button")) {
    //             evt.preventDefault();
    //         } else {
    //             // if (menuButton.classList.contains("js-active")) {
    //                 deactivateSubMenu();
    //         //     } else {
    //         //         activateSubMenu();
    //         //     }
    //         // }
    //     }, true);

    //     menuButton.addEventListener("click", function (evt) {
    //         evt.preventDefault();

    //         if (!menuButton.classList.contains("js-active")) {
    //             activateSubMenu();
    //         } else {
    //             deactivateSubMenu();
    //         }
    //     });
    // }

    const menuWrapper = document.querySelector(".js-menu-wrapper");
    const menuButton = document.querySelector(".js-sub-menu-trigger");

    const activateSubMenu = function () {
        menuWrapper.classList.add("js-active-submenu");
        menuButton.classList.add("js-active");
    }

    const deactivateSubMenu = function () {
        menuWrapper.classList.remove("js-active-submenu");
        menuButton.classList.remove("js-active");
    }

    if (menuButton) {
        document.body.addEventListener("click", function (evt) {
            if (!evt.target.closest(".main-menu__extra") && !evt.target.closest(".main-menu__more-button") && !evt.target.closest(".main-menu__link")) {
                deactivateSubMenu();
            }
        }, true);

        menuButton.addEventListener("click", function (evt) {
            evt.preventDefault();

            if (!menuButton.classList.contains("js-active")) {
                activateSubMenu();
            } else {
                deactivateSubMenu();
            }
        });
    }
});